import { useCallback } from 'react';
import { useAuthenticatedFetchWithWorkspace } from '../Keycloak/useAuthenticatedFetchWithWorkspace';

export interface CreateOfferInputPayload {
  communicationInput: string;
  title?: string;
  description?: string;
  offerNumber?: string;
  startValidityDate?: string;
  endValidityDate?: string;
  nbMaxEdit?: number;
  nbMaxUse?: number;
  refDiscountTypeId?: number;
  payloadRefDiscountType?: object;
  refEditConditionId?: number;
  payloadRefEditCondition?: object;
  refUseConditionId?: number;
  payloadRefUseCondition?: object;
}

const useCreateOfferInput = () => {
  const { authFetch, isReady } = useAuthenticatedFetchWithWorkspace();

  const createOfferInput = useCallback(
    async (payload: CreateOfferInputPayload): Promise<{ id: number } | null> => {
      if (!isReady) return null;
      try {
        return await authFetch('/offer_inputs', {
          method: 'POST',
          headers: { 'Content-Type': 'application/ld+json', Accept: 'application/ld+json' },
          body: JSON.stringify(payload),
        });
      } catch {
        return null;
      }
    },
    [authFetch, isReady],
  );

  return { createOfferInput };
};

export default useCreateOfferInput;
